import { useState } from "react";
import { uploadSignature } from "../../api/uploadService";

export const useUploadSignature = (successCallback) => {
  const [progress, setProgress] = useState(0);

  const upload = async (data) => {
    try {
      const newFile = await uploadSignature(data, setProgress);
      successCallback();
      setProgress(0); // reset after success
      return newFile;
    } catch (error) {
      console.error("Failed to upload file:", error);
      setProgress(0); // reset on error
      throw error;
    }
  };

  return { upload, progress };
};